<template>
  <div id="detailPage" class="detailPage">
    <div class="titleBox">
      <p class="title">基础信息</p>
    </div>    
    <!-- <el-button style="float:right" type="primary" size="small">打印</el-button> -->
    <ul class="ulBox clearFloat">
      <li>
        <div class="left">检验单号：</div>
        <div class="right">
          <span class="value" v-if="DetailData.orderNumber">{{
            DetailData.orderNumber
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">生产工单：</div>
        <div class="right">
          <span class="value" v-if="DetailData.originalOrder">{{
            DetailData.originalOrder.orderNumber
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">送检时间：</div>
        <div class="right">
          <span class="value" v-if="DetailData.createDateTime">{{
            DetailData.createDateTime
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">送检人：</div>
        <div class="right">
          <span class="value" v-if="DetailData.createUser"
            >{{ DetailData.createUser.name }}({{ DetailData.createUser.employeeNum }})</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">送检数量：</div>
        <div class="right">
          <span class="value" v-if="DetailData.batchQuantity"
            >{{ DetailData.batchQuantity }} PCS</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">累计数量：</div>
        <div class="right">
          <span class="value" v-if="DetailData.countQuantity"
            >{{ DetailData.countQuantity }} PCS</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">成品编码：</div>
        <div class="right">
          <span class="value" v-if="DetailData.itemCode">{{
            DetailData.itemCode
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">客户：</div>
        <div class="right">
          <span class="value" v-if="DetailData.customer">
            {{ DetailData.customer.name }} 
            </span>
        </div>
      </li>
      <li>
        <div class="left">工厂型号：</div>
        <div class="right">
          <span class="value" v-if="DetailData.product">{{
            DetailData.product.code
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">自定义型号：</div>
        <div class="right">
          <span class="value" v-if="DetailData.customerModel">
            {{DetailData.customerModel}}
            </span>
        </div>
      </li>
      <li>
        <div class="left">订单数量：</div>
        <div class="right">
          <span class="value" v-if="DetailData.orderCountQuantity"
            >{{ DetailData.orderCountQuantity }}</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">固件版本：</div>
        <div class="right">
          <span class="value" v-if="DetailData.fwVersion"
            >{{ DetailData.fwVersion }}</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">抽检批次号：</div>
        <div class="right">
          <span class="value" v-if="DetailData.partLot && DetailData.partLot!='WAIT'">
            {{ DetailData.partLot }}({{DetailData.checkDateTime}})
          </span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">抽检人：</div>
        <div class="right">
          <span class="value" v-if="DetailData.checkUser"
            >{{ DetailData.checkUser.name }}({{ DetailData.checkUser.employeeNum }})</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">状态：</div>
        <div class="right">
          <span class="value" v-if="DetailData.status"
            >{{ DetailData.status.title }}</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">测试工具：</div>
        <div class="right">
          <span class="value" v-if="DetailData.testTool && DetailData.testTool==1"
            >产测工具</span
          >
          <span class="value" v-else-if="DetailData.testTool && DetailData.testTool==2"
            >APP</span
          >
          <span class="value" v-else-if="DetailData.testTool && DetailData.testTool==3"
            >手动测试</span
          >
          <span class="value" v-else-if="DetailData.testTool && DetailData.testTool==4"
            >包装配件检查</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li v-if="DetailData.type=='OQC'">
        <div class="left">严重缺陷数：</div>
        <div class="right">
          <span class="value" 
            >{{ DetailData.criCount }} PCS</span
          >
        </div>
      </li>
      <li v-if="DetailData.type=='OQC'">
        <div class="left">主要缺陷数：</div>
        <div class="right">
          <span class="value" 
            >{{ DetailData.majCount }} PCS</span
          >
        </div>
      </li>
      <li v-if="DetailData.type=='OQC'">
        <div class="left">轻微缺陷数：</div>
        <div class="right">
          <span class="value" 
            >{{ DetailData.minCount }} PCS</span
          >
        </div>
      </li>
      <li>
        <div class="left">审核状态：</div>
        <div class="right">
          <span class="value" v-if="DetailData.verifyState==-1">待审核</span>
          <span v-else-if="DetailData.verifyState==0">审核通过</span>
          <span v-else-if="DetailData.verifyState==1">审核不通过</span>
        </div>
      </li>
      <li>
        <div class="left">审核人：</div>
        <div class="right">
          <span class="value" v-if="DetailData.verifyUser"
            >{{ DetailData.verifyUser.name }}({{ DetailData.verifyUser.employeeNum }})</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">审核时间：</div>
        <div class="right">
          <span class="value" v-if="DetailData.verifyDateTime"
            >{{ DetailData.verifyDateTime }}</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">入库时间：</div>
        <div class="right">
          <span class="value" v-if="DetailData.storageDateTime"
            >{{ DetailData.storageDateTime }}</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">入库人：</div>
        <div class="right">
          <span class="value" v-if="DetailData.storageDateTime"
            >{{ DetailData.storageUser.name }}({{ DetailData.storageUser.employeeNum }})</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li  class="blockLi">
        <div class="left">备注：</div>
        <div class="right">
          <span class="value" v-if="DetailData.remark"
            >{{ DetailData.remark }}</span
          >
          <span v-else>-</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import {
  apiQcCheckListDetail, 
} from "@/api/qcOrder.js";
export default {
  props: {
    tabPaneValue: {
      type: String,
    },
  },
  computed: {
  },
  components: {
    
  },
  data() {
    return {
      DetailData: {},
      SNData:[],
      pullDownData: {
        productOrderList: [],
      },
      dialogVisible: false,
      dialogTitle: "",
      dialogForm: {
      },
      dialogRules: {
        minBuild: [
          { required: true, message: "版本号不能为空！", trigger: "blur" },
        ],
      },
      labelWidth: this.$store.state.labelWidth,
      fileText: "未选择任何文件",
    };
  },
  methods: {
    // 详情
    async detail(callback) {
      const res = await apiQcCheckListDetail({
        id: this.tabPaneValue,
      });
      if (res.code == 0) {
        this.DetailData = res.data;
        this.$parent.settingType = this.DetailData.type;
        if (callback) callback();
      }
    },

  }
};
</script>

<style lang="less" scoped>
  .reCheck {
    color: #f56c6c; font-weight: bold; font-size: 16px;
  }
</style>
